const defaultImage = 'https://placehold.co/600x600';

export { 
  defaultImage 
}